import { LoginSuccessPage, NavigationHandler, PlatformProvider } from '@/shared/platform';
import { useToast } from '@/shared/ui';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { rcmPlatformConfig } from '@/app/config/platform';
import { queryClient } from '@/lib/queryClient';
import { registerToastNotifier } from '@/lib/toastBridge';

const LOGO_SRC = '/logo.svg';

function ToastBridgeWirer() {
  const { toast } = useToast();
  useEffect(() => {
    registerToastNotifier((message) => {
      toast({ title: 'Error', description: message, variant: 'error' });
    });
  }, [toast]);
  return null;
}

export function AppRoot() {
  return (
    // The app's own query client, shared with the platform's hooks so both use
    // one cache and one error policy (see AppProviders).
    <PlatformProvider config={rcmPlatformConfig} logoSrc={LOGO_SRC} queryClient={queryClient}>
      <ToastBridgeWirer />
      <NavigationHandler />
      <Outlet />
    </PlatformProvider>
  );
}

export function LoginOkRoute() {
  return <LoginSuccessPage logoSrc={LOGO_SRC} redirectTo="/" />;
}
